import { Component, Input } from "@angular/core"
import NavigationNode from "../../models/navigationNode.model"
import { Colors } from "../../models/colors.model"
import { Router } from "@angular/router"
import { GTMComponent } from "../../utils/gtmComponent"

@Component({
    selector: "app-side-navigation",
    templateUrl: "./side-navigation.component.html",
    styleUrls: ["./side-navigation.component.scss"],
    standalone: false,
})
export class SideNavigationComponent extends GTMComponent {
    @Input() navigationNode: NavigationNode
    @Input() activeNode: NavigationNode
    @Input() styles: Colors

    constructor(private router: Router) {
        super()
    }

    selectNode(node) {
        this.router.navigate([node.getRouterLink()])
    }
}
